module.exports = __webpack_public_path__ + "img/21.92a2f345.png";